import React from "react";
import {
  Button,
  Col, Container, Row,
} from "reactstrap";
import UserProfileForm from "components/Forms/UserProfileForm";
import Heading from "components/Heading";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss";

const UserProfile = props => {
  const FORM_ID = "userProfile";

  let navigate = useNavigate();

  return (
    <>
      <Heading yellowBg headingLevel="h2" className="pt-4 pb-4" label="Perfil de Usuario" sticky bordered >
        <Col sm={12} md={4} lg={3} xxl={2}>
          <Row>
            <Col>
              <Button color="danger" onClick={(e) => { navigate("/user/dashboard") }}> Cerrar</Button>
            </Col>
            <Col >
              <Button className="float-end" form={FORM_ID} type="submit" color="success"> Guardar</Button>
            </Col>
          </Row>
        </Col>
      </Heading>
      <Container className="mt-5 mb-5">
        <Row>
          <Col>
            <UserProfileForm className={styles.container} formId={FORM_ID} />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default UserProfile;
